import _http_v1 from "@packs/http_requests/_http_v1"
import store from "../store/store"
import toast from "@components/toast/toast"

const dam_helper = {
    saveDamGates(dam_id, floodgates){
        // console.log(floodgates);
        _http_v1.request('events/new_event', 'POST', {save_reference:true, eventable_id: dam_id, eventable_type: 'Dam', start_date: new Date().toISOString(), desc: 'Mudança status comportas', options:{gates:floodgates}, event_type_id: 1}).then(data=>{
            toast.success({text: 'Comportas atualizadas'})
            store.damStore.setDamEvent(dam_id,[data])
        }).fail(_=>{
            toast.warning({text: 'Erro ao atualizar comportas :('})
        })
    },
    //ultimo evento com situação das comportas
    getDamGates(dam_id){
        return _.get(store.damStore.getDam(dam_id), 'last_event.[0].options.gates')
    },
    //configuração inicial das comportas
    getDamDefaultGates(dam_id){
        return _.get(store.damStore.getDam(dam_id), 'params.gates')
    },
    //cruza os valores de vazão com o numero de comportas da barragem
    flowWithFloodgates(measurements){
        let dam_id = store.informationCardStore.getDamId()
        let dam = store.damStore.getDam(dam_id)
        let events = JSON.parse(JSON.stringify(Object.values(dam.events)))

        events.map(x=>x.start_date = new Date(x.start_date).getTime())

        measurements.forEach((timestamp)=>{
            let obj = {start_date:timestamp.x}
            let new_array = [...events, obj]
            let sort = _.sortBy(new_array, ['start_date'])
            let indexOf = sort.findIndex(x=>x.start_date === timestamp.x)
            let before_event = sort[indexOf - 1]
            let after_event = sort[indexOf + 1]

            if(before_event){
                let gates = _.get(before_event, 'options.gates')
                if(gates){
                    let count = Object.values(gates).filter(x=>x.status === 'true' || x.status === true).length
                    timestamp.y *= count
                    timestamp.a = count //comportas
                }
            }
        })
        
        return measurements 
    }
}

export default dam_helper